<template>
  <div v-if="disabled" class="-add -action -disabled">
    <span class="wticon wticon-plus"></span>
  </div>
  <div
    v-else
    class="-add -action"
    @click="$emit('add')"
    v-tooltip="tooltipOptions"
  >
    <span class="wticon wticon-plus"></span>
  </div>
</template>

<script>
export default {
  name: 'AssetAdd',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltipOptions() {
      return {
        title: 'Add to timeline',
        placement: 'top auto',
        wrapperClass: 'dark',
        delay: { show: 250, hide: 0 },
        container: '.tooltip-container',
      };
    },
  },
};
</script>
